import { VIPER_CONST } from "../commonConstant";
import * as BaseApi from "../configs/api-config";
import { IThemeGalleryReq, IThemeGalleryRes } from "../types";

class ThemeGalleryAPiService {
    private url = (action: string) => VIPER_CONST.base_url + action


    public async themeGallery(request: IThemeGalleryReq): Promise<IThemeGalleryRes | any> {
        return BaseApi._post(this.url("getthemegallery"), request);
    }
}

const ThemeGalleryApi = new ThemeGalleryAPiService();

export default ThemeGalleryApi;